export function usesEnglish() {
  return !!window.locale.match(/^en/);
}



// WEBPACK FOOTER //
// ./app/common/lib/util/locale.ts